import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
import { EditClientModal } from '../EditClientModal';
const DEFAULTS = {
    id: 0,
    code: '',
    name: '',
    employerId: 0,
    createdAt: '',
    updatedAt: '',
    isActive: false,
};
export const AddClient = ({ onSave }) => {
    const [showModal, setShowModal] = useState(false);
    const { t } = useLocale();
    const handleSave = () => {
        setShowModal(false);
        onSave();
    };
    return (_jsxs(_Fragment, { children: [_jsx(TrackableButton, { btnType: 'mui', enText: 'Add Client', tag: 'header', variant: 'contained', onClick: () => setShowModal(true), children: t('Add Client') }), showModal && (_jsx(EditClientModal, { client: DEFAULTS, onCancel: () => setShowModal(false), onSave: handleSave }))] }));
};
